module.exports = __webpack_public_path__ + "static/media/atlantix-zen-feature.3184ba03.jpg";